import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { fonts } from "theme/fonts";
import { firebase, EventContext, UserContext, AnalyticsContext } from "context";
import { useDocumentData } from "react-firebase-hooks/firestore";

export const PoweredBy = ({ zipCode, postCampaign }) => {
  const [dealer, setDealer] = useState();
  const [fdaf, loading, error] = useDocumentData(
    firebase.firestore().doc(`geo/ford/fdaf/${zipCode}`)
  );
  console.log("faf", fdaf, dealer);
  let string = fdaf?.fdaf;
  useEffect(() => {
    if (
      string === "Greater Texas Ford" ||
      string === "North Texas Ford" ||
      string === "South Texas Ford" ||
      string === "Houston Ford" ||
      string === "Northern California Ford" ||
      string === "Desert Ford Dealers"
    ) {
      let newStr = string
        .replace("Greater Texas Ford", "Tus Concesionarios Ford de Tejas")
        .replace(
          "North Texas Ford",
          " Tus Concesionarios Ford del Norte de Tejas"
        )
        .replace("South Texas Ford", " Tus Concesionarios Ford de Tejas")
        .replace("Houston Ford", " Tus Concesionarios Ford de Tejas")
        .replace("Northern California Ford", "Your California Ford Dealers")
        .replace("Desert Ford Dealers", "Tus Concesionarios Desert Ford");
      setDealer(newStr);
    }
  }, [string]);

  if (loading) return null;

  return (
    <PoweredByWrapper postCampaign={postCampaign}>
      <SubBody>
        Impulsado por {dealer ? dealer : "Tus Concesionarios Ford"}
      </SubBody>
    </PoweredByWrapper>
  );
};
const topBorder = `
  border-top: 1px solid #707070;
  padding-top: 24px;
  margin-top: 24px;
`;

const PoweredByWrapper = styled.div`
  ${topBorder}
  ${(props) => props.postCampaign && "border-top: 0px solid #707070;"}
`;
const SubBody = styled.p`
  font-size: 0.65rem;
  @media (max-width: 950px) {
    font-size: 0.9rem;
  }
`;
